import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Avatar, Dialog, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, useTheme} from "@mui/material";
import {setLocale} from "../session_state/session_state_reducer";
import gbflag from "/assets/gb.svg"
import slflag from "/assets/si.svg"
import {RootState} from "../store";

type LanguageDialogProps = {

    setSwitchLang: (swicth: boolean) => void,
}

type Language = {
    title: string,
    flag: ImageSourcePropType,
    locale: string
}

const languages: Language[] = [
    {
        title: "English",
        locale: "en",
        flag: gbflag
    },
    {
        title: "Slovensko",
        locale: "sl",
        flag: slflag
    },
];
export default ({setSwitchLang}: LanguageDialogProps) => {
    const dispatch = useDispatch();
    const locale = useSelector<RootState,string>(s => s.sessionState.locale) || "sl"
    const theme = useTheme();

    return <Dialog open={true}
                   onClose={() => setSwitchLang(false)}>

            <List>
                {languages.map((lang) => {
                    return <ListItem

                        key={lang.locale} alignItems="flex-start" onClick={() => {
                            setSwitchLang(false);
                            dispatch(setLocale(lang.locale));
                        }}>
                        <ListItemButton selected={lang.locale === locale}>
                            <ListItemAvatar>
                                <Avatar alt={lang.title} src={lang.flag}  />
                            </ListItemAvatar>
                            <ListItemText
                                primary={lang.title}
                            />
                        </ListItemButton>
                    </ListItem>
                })}
            </List>

    </Dialog>;
}
